export default __webpack_public_path__ + "static/media/checkbox.3cd2801b.svg";